// extracted by mini-css-extract-plugin
module.exports = {"controlPanelWrpr":"user-profile_controlPanelWrpr__1yRAB","profileNav":"user-profile_profileNav__1BJB7","navWrap":"user-profile_navWrap__30c53"};